import { em } from 'polished'
import styled from 'styled-components'

import Link from 'components/Link'

export const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  height: ${em(50)};
  border-bottom: 1px solid ${p => p.theme.colors.blackOp1};
  background: ${p => p.theme.colors.white};

  ${p => p.theme.mq.upLg} {
    height: ${em(66)};
  }
`

export const Inner = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 ${em(20)};

  ${p => p.theme.mq.upLg} {
    max-width: ${em(1368)};
    margin: 0 auto;
    padding: 0 ${em(40)};
  }
`

export const BackLink = styled(Link)`
  position: absolute;
  left: ${em(20)};
  top: ${em(15)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: ${em(20.055)};
  height: ${em(21)};
  color: ${p => p.theme.colors.black};

  ${p => p.theme.mq.upLg} {
    position: static;
    left: auto;
    top: auto;
  }
`

export const BackIcon = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`

export const LogoLink = styled(Link)`
  position: absolute;
  left: 50%;
  top: ${em(17)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${em(71.7234)};
  height: ${em(16)};
  transform: translateX(-50%);
  color: ${p => p.theme.colors.black};

  ${p => p.theme.mq.upLg} {
    top: 50%;
    transform: translate(-50%, -50%);
  }
`

export const LogoIcon = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`

export const DesktopContacts = styled.div`
  display: none;

  ${p => p.theme.mq.upLg} {
    display: inline-flex;
    align-items: center;
    gap: ${em(30)};
  }
`

export const DesktopContactLink = styled(Link)`
  color: ${p => p.theme.colors.black};
  font-family: ${p => p.theme.typography.regularFont};
  font-size: ${em(16)};
  line-height: ${em(20, 16)};
  white-space: nowrap;
  text-decoration: ${p => (p.$isUnderline ? 'underline' : 'none')};
  text-decoration-skip-ink: none;
  transition: opacity ${p => p.theme.animation.timeStandard} ease;

  &:hover {
    opacity: 0.5;
    text-decoration: ${p => (p.$isUnderline ? 'underline' : 'none')};
  }
`

export const MobileActions = styled.div`
  position: absolute;
  right: ${em(20)};
  top: ${em(15)};
  display: inline-flex;
  align-items: center;
  gap: ${em(15)};

  ${p => p.theme.mq.upLg} {
    display: none;
    position: static;
    right: auto;
    top: auto;
  }
`

export const MobileActionLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: ${em(20)};
  height: ${em(20)};
  color: ${p => p.theme.colors.black};
`

export const MobileActionIcon = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`
